import { Pipe, PipeTransform } from '@angular/core';
import { Item } from '@app/core/services/cart/cart.service';

@Pipe({
    name: 'brandProductFilter',
    standalone: true
})
export class BrandProductFilterPipe implements PipeTransform {
    constructor() {}

    transform(
        items: Item[],
        brand_id?: number,
        filter_out_subscription_item?: boolean,
        samplingProductsIds = new Set([])
    ): Item[] {
        if (!items) {
            return [];
        }

        return items.filter((item: Item) => {
            if (samplingProductsIds.size && samplingProductsIds.has(item.ids.product_size_id)) {
                return false;
            }

            const isSubscriptionItem = item.is_subscription_item;

            if (isSubscriptionItem && filter_out_subscription_item) {
                return false;
            }

            return item.brand_id === brand_id;
        });
    }
}
